export default __webpack_public_path__ + "static/media/rocket_anim_75.f9c4d3c3.png";